import { Map } from 'immutable';
import {default as cocViewReducer} from './cocViewReducer';
import {default as cocTestFormReducer} from './cocTestFormReducer.js';

let defaultState = {};

export default function(state = Map(defaultState), action) {

  state = state.set('cocView', cocViewReducer(state.get('cocView'), action));
  state = state.set('cocTestForm', cocTestFormReducer(state.get('cocTestForm'), action));

  return state;
}
